import SpriteSymbol from "../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "tick",
  "use": "tick-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"tick\"><path d=\"M11.793 4.266L5.535 9.731 3.83 8.007c-.38-.383-1.039-.423-1.473-.086-.435.336-.478.918-.098 1.302l2.435 2.462A1.102 1.102 0 005.48 12c.274 0 .538-.095.734-.266L13.26 5.58a.85.85 0 00.009-1.306 1.143 1.143 0 00-1.476-.008\" fill=\"currentColor\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol